import type { ReactNode } from 'react'

/** The strip along the top of the chat side panel that holds its tabs. */
export default function ChatPanelTabBar({ children }: { children: ReactNode }) {
  return (
    // Tabs sit on the bar's bottom edge, so the bar is padded on three sides and the open tab covers the border.
    <div className="flex shrink-0 items-start gap-2 border-b border-brand-neutral-300 bg-brand-neutral-200 px-2 pt-2">{children}</div>
  )
}
